export default {
  'extraUserFields.title': 'Gestionar Campos Extra de Usuario',

  'extraUserFields.isAllowMultipleChoicesEnabled': '¿Permitir Selección Múltiple?',
  'extraUserFields.isAutoSelectItemEnabled': '¿Auto Seleccionar Elemento?',
  'extraUserFields.isAllowInsertOptionManuallyEnabled': '¿Permitir Insertar Opción Manualmente?',
  'extraUserFields.choices': 'Opciones',
  'extraUserFields.dynamicTableFieldOrderDirection': 'Forma de Ordenar',
  'extraUserFields.groupingType': 'Tipo de Agrupación Resultados',
  'extraUserFields.dynamicEntity': 'Entidad Dinámica',
  'extraUserFields.dynamicEntityField': 'Campo Entidad Dinámica',
};
